import { FC, useEffect, useState } from "react"
import { IdTableVariant, LoadingStatus } from "../../../@types/enumsGlobal"
import { PluginWrapper } from "../../../components/plugins"
import { LabelPrintingDataProvider } from "../../../Services/DataProviders/LabelPrintingDataProvider"
import useGridFilter, { CreateSelectorGridFilter } from "../../../system/hooks/useGridFilter"
import { useAppContext } from "../../../system/providers/appContextProvider"
import { ILabelPrintLot } from "../Shared/Interfaces/ILabelPrintLot"
import { ChangeableGrid, IChangeDataGrid } from "../../../components/grids/changeableGrid/ChangeableGrid"
import GridWrapper from "../../../components/controls/GridWrapper"
import { IOption, Select } from "../../../components/selects/select"
import { LabelPrintScenarioDataProvider } from "../../../Services/DataProviders/LabelPrintScenarioDataProvider"
import { maxNumberPerPage } from "../../../components/grids/default/defaultGrid"
import _ from 'underscore'

export interface IViewLabelsFilter {
    Item1: {
        ids: string[]
        filter: IGridFilter
    },
    Item2: IGridFilter
}

export interface ISelectingPrintItems extends IGridProps {
    idTable: IdTableVariant
    documentsIds: Array<string>
    isKiz: boolean
    quantity: number
    scenarioId: string | undefined
    materGridFilter?: IGridFilter
    onMultipleSelectRows: (rows: IGridRow[]) => void
    onQuantityChanged: (has: boolean) => void
    onScenarioChanged: (id: string) => void
}

export const LotSelectorPluginViewNew: FC<ISelectingPrintItems> = (props) => {
    const appCtx = useAppContext();
    const dataProvider = new LabelPrintingDataProvider(appCtx.reportAPIService);
    const dataProviderScenarios = new LabelPrintScenarioDataProvider(appCtx.coreApiService);

    const [data, setData] = useState<ILabelPrintLot[]>([]);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [gridFilter, dispatchGridFilter] = useGridFilter();
    const [selectedItem, setSelectedItem] = useState<IGridRow>();
    const [selectedItems, setSelectedItems] = useState<IGridRow[]>([]);
    const [viewState, setViewState] = useState<GridStateType>("refresh");
    const [loadingStatus, setLoadingStatus] = useState<LoadingStatus>(LoadingStatus.InProcess)
    const [scenarios, setScenarios] = useState<Array<IOption>>([])
    const [selectedScenario, setSelectedScenario] = useState<IOption>()
    const [gridFilterScen, dispatchGridFilterScen] = useGridFilter(CreateSelectorGridFilter);

    useEffect(() => {
        // componentDidMount events
        gridFilterScen.numberPerPage = maxNumberPerPage;
        gridFilterScen.fieldOrderBy = "name"
        return () => {
            // componentWillUnmount events
        }
    }, [])

    useEffect(() => {
        if (viewState === 'refresh') {
            setViewState('view')
            dataProviderScenarios.getView(gridFilterScen, async (e, totalCount) => {
                if (data) {
                    const arr: Array<IOption> = new Array<IOption>()
                    let selected: IOption | undefined = undefined
                    e.forEach(item => {
                        const op: IOption = { displayName: item.displayName, value: item.idGlobal }
                        if (selected == undefined && props.scenarioId != undefined && props.scenarioId === item.idGlobal) {
                            selected = op
                        }
                        arr.push(op)
                    })
                    setScenarios([...arr])
                    if (selected === undefined) {
                        selected = arr[0]
                        props.onScenarioChanged(selected.value)
                    }
                    setSelectedScenario(selected)
                }
            })
            const payload = { Item1: { ids: props.documentsIds, filter: gridFilter }, Item2: props.materGridFilter } as IViewLabelsFilter
            dataProvider.getViewByParams(props.idTable, payload, props.isKiz, (e: Array<ILabelPrintLot>, c: Array<IGridColumn>) => {
                if (props.plugin.columns.length == 0) {
                    props.plugin.columns.push(...c)
                }
                const totalCount = e.length
                if (totalCount > 0) {
                    e.forEach(f => f.labelQuantity = props.quantity)
                    setLoadingStatus(LoadingStatus.Completed)
                } else {
                    setLoadingStatus(LoadingStatus.NoData)
                }
                setData(e)
                setTotalCount(totalCount)
            }, () => {
                setLoadingStatus(LoadingStatus.Failed)
            })
        }
    }, [viewState, gridFilter])

    const changeData = (changeData: IChangeDataGrid) => {
        const val = changeData.value as number
        const result = setData(data.map((item) => (item.idGlobal === changeData.idGlobal ? { ...item, labelQuantity: val } : item)))
        let hasData = val > 0
        if (!hasData) {
            _.any(data, (lot: ILabelPrintLot) => lot.labelQuantity > 0)
        }
        props.onQuantityChanged(hasData)
        return result
    }

    return (
        <PluginWrapper>
            <GridWrapper cols={1}>
                <Select
                    required
                    label='Сценарий печати этикеток'
                    onSelect={(option) => {
                        setSelectedScenario(option)
                        props.onScenarioChanged(option.value)
                    }}
                    options={scenarios}
                    value={selectedScenario}
                />
            </GridWrapper>
            <ChangeableGrid
                gridId={props.gridId}
                data={data}
                documentStateProc={false}
                totalCount={totalCount}
                filter={gridFilter}
                dataProvider={dataProvider}
                plugin={props.plugin}
                selectedItem={selectedItem}
                selectedItems={selectedItems}
                multipleSelect={true}
                onDoubleClick={(row) => props.onDoubleClick?.(row)}
                onMultipleSelect={(rows) => {
                    setSelectedItems(rows)
                    props.onMultipleSelectRows?.(rows)
                }}
                onSelect={(row) => {
                    setSelectedItem(row)
                }}
                onChangeData={(e) => changeData(e)}
                onSort={(i) => dispatchGridFilter({ type: "sort", payload: i.propertyName })}
                onFilterDelete={(i) => { }}
                onPageNumberChange={(n) => { }}
                onNumberPerPageChange={(n) => { }}
                onEnter={() => setViewState("edit")}
            />
        </PluginWrapper>
    )
}